import { Spinner } from '@fukuri-admins/ui/common';
import clsx from 'clsx';
import { Suspense } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { IS_STRESS_CHECK_IMPLEMENTER_BUILD } from '~/constants';
import { ClientSideMenu } from '~/features/ClientSideMenu';
import { StressAssessmentReportBreadcrumb } from '~/features/StressAssessmentReportBreadcrumb';
import { StressAssessmentScheduleNotificationBanner } from '~/features/StressAssessmentScheduleNotificationBanner';
import { StressAssessmentSummary } from '~/features/StressAssessmentSummary';
import { StressAssessmentUserReportList } from '~/features/StressAssessmentUserReportList';
import { ROUTES } from '~/utils/routes';
import styles from './styles.module.scss';

export const Screen: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  const stressAssessmentId = Number.parseInt(id || '', 10);

  if (Number.isNaN(stressAssessmentId)) {
    // idが数値でない場合は、stress-assessmentsにリダイレクト
    return <Navigate to={ROUTES.STRESS_ASSESSMENTS.INDEX} replace />;
  }

  return (
    <div
      className={clsx(styles.Screen, {
        [styles.NoSideMenu]: IS_STRESS_CHECK_IMPLEMENTER_BUILD,
      })}
    >
      {!IS_STRESS_CHECK_IMPLEMENTER_BUILD && <ClientSideMenu />}
      <div className={styles.ContentWrapper}>
        <div className={styles.BreadcrumbWrapper}>
          <Suspense fallback={null}>
            <StressAssessmentReportBreadcrumb stressAssessmentId={stressAssessmentId} />
          </Suspense>
        </div>
        <div className={styles.Content}>
          <Suspense fallback={<Spinner />}>
            <StressAssessmentSummary stressAssessmentId={stressAssessmentId} />
            <StressAssessmentUserReportList stressAssessmentId={stressAssessmentId} />
          </Suspense>
        </div>
      </div>
      {!IS_STRESS_CHECK_IMPLEMENTER_BUILD && (
        <div className={styles.BannerWrapper}>
          <Suspense fallback={null}>
            <StressAssessmentScheduleNotificationBanner />
          </Suspense>
        </div>
      )}
    </div>
  );
};
